'use strict';

/* globals define, app, ajaxify, socket */

require(["benchpress"], function (Benchpress) {
	Benchpress.registerHelper('generateConnectTitles', function(data) {
	    var html = '';
	    var i;
	    var item;
	    if(data.user) {
	    	data = data.user;
	    }
	    if(data && data.connectTitles) {
	    	if(data.connectTitles.isModSenior) {
	    		html += '<span class="label label-default inline-block label-info">ModSenior</span> ';
	    	} else {
	    		if(data.connectTitles.connectModeratorGroups && data.connectTitles.connectModeratorGroups.length) {
	    			for(i in data.connectTitles.connectModeratorGroups) {
		    			item = data.connectTitles.connectModeratorGroups[i];
		    			html += '<span class="label label-default inline-block" style="background-color: '+item.labelColor+';">'+( (item.icon) ? '<i class="fa '+item.icon+'"></i>' : '')+' '+item.userTitle+'</span> ';
		    		}
		    	} else {
		    		if(data.connectTitles.connect_badges_expert && data.connectTitles.connect_badges_expert.length) {
		    			for(i in data.connectTitles.connect_badges_expert) {
			    			item = data.connectTitles.connect_badges_expert[i];
			    			html += '<span class="label label-default inline-block" style="background-color: '+item.labelColor+';">'+( (item.icon) ? '<i class="fa '+item.icon+'"></i>' : '')+' '+item.name+'</span> ';
			    		}
			    	}
		    		if(data.connectTitles.connect_badges_honoremtitle && data.connectTitles.connect_badges_honoremtitle.length) {
		    			for(i in data.connectTitles.connect_badges_honoremtitle) {
			    			item = data.connectTitles.connect_badges_honoremtitle[i];
			    			html += '<span class="label label-default inline-block" style="background-color: '+item.labelColor+';">'+( (item.icon) ? '<i class="fa '+item.icon+'"></i>' : '')+' '+item.name+'</span> ';
		    			}
		    		}
		    		if(data.connectTitles.connect_badges_contributor) {
		    			item = data.connectTitles.connect_badges_contributor;
		    			html += '<span class="label label-default inline-block" style="background-color: '+item.labelColor+';">'+( (item.icon) ? '<i class="fa '+item.icon+'"></i>' : '')+' '+item.name+'</span> ';
		    		} else {
		    			if(data.connectTitles.connect_badges_title) {
			    			item = data.connectTitles.connect_badges_title;
			    			html += '<span class="label label-default inline-block" style="background-color: '+item.labelColor+';">'+( (item.icon) ? '<i class="fa '+item.icon+'"></i>' : '')+' '+item.name+'</span> ';
			    		} else {
			    			if(data.connectTitles.selectedGroup.slug) {
				    			item = data.connectTitles.selectedGroup;
				    			html += '<span class="label label-default inline-block" style="background-color: '+item.labelColor+';">'+( (item.icon) ? '<i class="fa '+item.icon+'"></i>' : '')+' '+item.userTitle+'</span> ';
				    		}
			    		}
		    		}
		    	}
	    	}
	    }
	    return html;
	});
});

/*
(function() {

	
}());
*/

define('forum/account/karma-penalita', function() {
    var MCP = {};

    MCP.init = function() {
        $('#karma-penalita-button').on('click', function() {
        	var punti = $('#karma-penalita-punti').val();
        	if (/^\d+$/.test(punti)) {
        		socket.emit('plugins.connectBadges.karmaPenalita.save', {uid: ajaxify.data.user.uid, punti:punti}, function(err) {
	                if (err) {
	                    app.alertError(err.message);
	                    return false;
	                }
	                ajaxify.refresh();
	                return true;
	            });
        	} else {
        		app.alertError('Inserire un numero intero');
        	}
        });
    };

    return MCP;
});